import React, { useEffect, useState } from 'react';
import Universalpageheader from '../Headers/universalpageheader';
import Productcard from '../Products/productcard';
import { Button, CircularProgress, Box, Typography, Paper, Divider, Skeleton, Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Searchbar from '../Components/searchbar';
import Errorcomponent from '../Components/errorcomponent';
import fetch from '../Utils/fetch';
import { imageurl } from '../Utils/fn';
import { capitalizeFirst, currencyseperator } from '../Utils/functions';


function Orderspage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const subProducts = useSelector((state) => state.subProducts.data);

    const [orders, setorders] = useState([]);

    const [loading, setloading] = useState(false);
    const [error, seterror] = useState("");
    const [showsearchbar, setshowsearchbar] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        setloading(true)
        fetch.get('getCustomerOrders').then(response => {
            setloading(false)
            if (!response.error) {
                setorders(response.data.orders.flatMap(order =>
                    order.items.map(item => ({
                        ...item,
                        order_number: order.order_number,
                        order_date: order.order_date,
                        order_type: order.order_type,
                        paid: order.payment_complete,
                        order_reference: order.reference_number,
                        order_amount: order.amount,
                        branch: order.branch || order.location
                    }))
                ))
            }
        }).catch(error => {
            setloading(false)
            seterror(error || "Sorry an error occurred,try again later");
        });
    }, []);



    return (
        <div className="homebody">
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader onshowsearch={() => setshowsearchbar(true)} pagename={"Orders"} withbackicon={true} />
            <div style={{ padding: '0 10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '10px' }}>
                    {loading ? (
                        Array.from({ length: 5 }).map((_, key) => (
                            <OrderProductCardSkeleton key={key} />
                        ))
                    ) : (
                        orders?.map((val, key) => (
                            <OrderProductCard item={val} key={key} />
                        ))
                    )}
                </div>
                {!loading && orders?.length < 1 && <Errorcomponent error={"You have no orders at the moment"} />}
            </div>
        </div>
    );
}

const OrderProductCard = ({ item }) => {
    const navigate = useNavigate();
    const webSettings = useSelector((state) => state.webSettings.data);

    const viewProduct = () => {
        navigate('/order-product', {
            state: { item: item }
        });
    };

    return (
        <Paper
            elevation={0}
            onClick={viewProduct}
            sx={{
                p: 1.5,
                borderRadius: 3,
                display: 'flex',
                gap: 2,
                cursor: 'pointer',
                border: '1px solid',
                borderColor: 'divider',
                transition: 'all 0.2s',
                '&:hover': {
                    borderColor: 'primary.main',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                    transform: 'translateY(-2px)'
                }
            }}
        >
            {/* Product Image */}
            <Box
                sx={{
                    width: 90,
                    height: 90,
                    borderRadius: 2,
                    overflow: 'hidden',
                    flexShrink: 0,
                    bgcolor: 'grey.100'
                }}
            >
                <img
                    src={imageurl(item.src?.[0])}
                    alt={item.item_name}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={(e) => { e.target.src = 'https://via.placeholder.com/150'; }}
                />
            </Box>

            {/* Product Details */}
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontWeight: 600,
                            lineHeight: 1.2,
                            mb: 0.5,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {capitalizeFirst(item.item_name)}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                        <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 600, bgcolor: 'primary.main' + '15', px: 1, borderRadius: 1 }}>
                            #{item.order_number}
                        </Typography>
                        {item.paid ? (
                            <CheckCircleIcon sx={{ color: 'success.main', fontSize: '1.2rem' }} />
                        ) : (
                            <PendingActionsIcon sx={{ color: 'warning.main', fontSize: '1.2rem' }} />
                        )}
                    </Box>
                </Box>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontSize: '0.8rem' }}>
                    {item.group_name} • {item.quantity} {item.suom || 'Unit(s)'}
                </Typography>

                <Divider sx={{ my: 1, borderStyle: 'dashed' }} />

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                    <Box>
                        <Typography variant="caption" display="block" color="text.disabled" sx={{ fontSize: '0.7rem' }}>
                            Ref: {item.reference_number?.substring(0, 15)}...
                        </Typography>
                        <Typography variant="caption" display="block" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                            {new Date(item.order_date).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })}
                        </Typography>
                    </Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary' }}>
                        <span style={{ fontSize: '0.75rem', fontWeight: 500, marginRight: '2px' }}>{webSettings.CURRENCY}</span>
                        {currencyseperator(parseFloat(item.amount_value).toFixed(2))}
                    </Typography>
                </Box>
            </Box>
        </Paper>
    );
};

const OrderProductCardSkeleton = () => {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 1.5,
                borderRadius: 3,
                display: 'flex',
                gap: 2,
                border: '1px solid',
                borderColor: 'divider',
            }}
        >
            <Skeleton variant="rectangular" width={90} height={90} sx={{ borderRadius: 2, flexShrink: 0 }} />
            <Box sx={{ flexGrow: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Skeleton variant="text" width="60%" height={24} />
                    <Skeleton variant="rectangular" width={40} height={20} sx={{ borderRadius: 1 }} />
                </Box>
                <Skeleton variant="text" width="40%" height={16} sx={{ mb: 1 }} />
                <Divider sx={{ my: 1, borderStyle: 'dashed' }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                    <Box sx={{ width: '40%' }}>
                        <Skeleton variant="text" width="100%" height={12} />
                        <Skeleton variant="text" width="80%" height={12} />
                    </Box>
                    <Skeleton variant="text" width="20%" height={24} />
                </Box>
            </Box>
        </Paper>
    );
};

export default Orderspage;
